import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

/**
 * Bootstrap 按鈕 + 小型 spinner，isLoading 時自動 disabled。
 * 沿用專案既有 inline pattern（spinner-border-sm me-2）。
 *
 * SPINNER_DELAY_MS：disabled 立即生效（防連點），spinner 延遲後才顯示。
 * 快的 API 在 spinner 出現前就回來了，不會有閃一下的突兀感；
 * 慢的 API（report、subscribe、donate）照常顯示等待中。
 */
const SPINNER_DELAY_MS = 300;

const LoadingButton = ({
  isLoading = false,
  disabled = false,
  className = 'btn',
  type = 'button',
  children,
  ...rest
}) => {
  const [showSpinner, setShowSpinner] = useState(false);

  useEffect(() => {
    if (!isLoading) {
      setShowSpinner(false);
      return;
    }
    const timer = setTimeout(() => setShowSpinner(true), SPINNER_DELAY_MS);
    return () => clearTimeout(timer);
  }, [isLoading]);

  return (
    <button
      type={type}
      className={className}
      disabled={isLoading || disabled}
      aria-busy={isLoading}
      {...rest}
    >
      {showSpinner && (
        <span
          className="spinner-border spinner-border-sm me-2"
          role="status"
          aria-hidden="true"
        />
      )}
      {children}
    </button>
  );
};

LoadingButton.propTypes = {
  isLoading: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  type: PropTypes.string,
  children: PropTypes.node,
};

export default LoadingButton;
